import React from 'react';
import { isTestMode } from '~/lib/TestModeHelpers.js';

const PreviewBookingBanner = ({ form }) => {
    const business = form?.business;
    const businessId = business?.id || form?.business_id;

    const isTest = isTestMode() || !!business?.test_mode;

    if (!isTest || !businessId) {
        return null;
    }

    return (
        <div className="bg-primary-100 text-center py-4">
            👀 You’re previewing your booking page in Test Mode: <a href={`https://app.breely.com/business/${businessId}/calendar`} className="text-primary-700 no-underline hover:underline">Return to Dashboard ↗</a>
        </div>
    );
}

export default PreviewBookingBanner;
